import React, { useState, useEffect } from 'react'
import { Select, Spin } from 'antd'
import { queryClinicEmployeeByRole } from '@/services/basicinfo'
import { HTTP_SUCCESS_CODE } from '@/utils/consts'
import { queryEmployeesByClinicId } from '@/services/employee'

const { Option, OptGroup } = Select

const ClinicUserPicker = ({ value, onChange, roleName, size, clinicId, currentUser, from, modalType, frequentList, initialValue, ...other }) => {
  const [users, setUsers] = useState(() => {
    if (currentUser) return [{ userId: currentUser.id, name: currentUser.nickname }]
    return []
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchUserByRoleId({ clinicId, roleName })
  }, [roleName, clinicId])

  // 获取诊所某种角色的用户
  const fetchUserByRoleId = async ({ clinicId, roleName }) => {
    if (!clinicId || !roleName) return

    setLoading(true)
    // const res = await queryClinicEmployeeByRole({roleName, clinicId}) 
    // 原先只获取私人管家的人 现在是所有人
    const res = await queryEmployeesByClinicId({ clinic_id: clinicId })
    setLoading(false)

    if (!res || res.code !== HTTP_SUCCESS_CODE) return
    let users = res.data || []

    if (currentUser) {
      const index = users.findIndex(_ => _.id === currentUser.id)

      if (index < 0) {
        users = users.concat({ userId: currentUser.id, name: currentUser.nickname })
      }
    }

    setUsers(users)
  }

  const selectProps = {
    ...other,
    size,
    value,
    onChange,
    placeholder: '输入姓名搜索',
    showSearch: true,
    allowClear: true,
    filterOption: (input, option) => option.props.children.indexOf(input) >= 0,
    optionFilterProp: 'children',
    notFoundContent: loading ? <Spin /> : '暂无内容',
    getPopupContainer: triggerNode => triggerNode.parentNode,
  }

  return (
    <Select {...selectProps}>
      <OptGroup label='常用人选'>
        {
          frequentList && frequentList.map(i => {
            return <Option value={i.userId}>{i.name}</Option>
          })
        }
      </OptGroup>
      {from === 'personal' ?
        // users.filter((_)=>{ return modalType === 'add'?(_.locked?!_.locked:_.enable):(_.locked?(initialValue ? Number(initialValue) === _.userId :false):(_.enable?_.enable:(initialValue ? Number(initialValue) === _.userId :false)))  } ).map(user => (
        users.map(user => (
          <Option key={user.userId} value={user.userId}>{user.name}</Option>
        ))
        :
        users.map(user => (
          <Option key={user.userId} value={user.userId}>{user.name}</Option>
        ))
      }
    </Select>
  )
}

export default ClinicUserPicker
